// extracted by mini-css-extract-plugin
export var chevron = "_jx-4";
export var chevronExpanded = "_jx-5";
export var row = "_jx-0";
export var rowBody = "_jx-6";
export var rowDescription = "_jx-7";
export var rowHeader = "_jx-1";
export var rowTitle = "_jx-2";
export var rowTitleComplete = "_jx-3";